import React from "react";
import { StyleSheet, Text, View } from "react-native";
import SimpleLineIcons from "@expo/vector-icons/SimpleLineIcons";

import SettingsOption from "./SettingsItem";

import type { SettingGroup } from "@/schemas/screen/settings";

type SettingsGroupProps = {
  group: SettingGroup;
};

function SettingsSection({ group }: SettingsGroupProps): React.JSX.Element {
  return (
    <View style={styles.container}>
      <View style={styles.sectionContainer}>
        <SimpleLineIcons name={group.icon} size={20} color="#000000" />
        <Text style={styles.groupName}>{group.name}</Text>
      </View>
      <View style={styles.itemsContainer}>
        {group.items.map((item) => (
          <SettingsOption key={item.id} item={item} />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 20,
  },
  sectionContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  groupName: {
    fontSize: 20,
    fontWeight: "600",
    left: 15,
  },
  itemsContainer: {
    backgroundColor: "#fff",
    borderRadius: 12,
    overflow: "hidden",
  },
});

export default SettingsSection;
